import SourceFlowHead from "@sourceflow-uk/sourceflow-head";
import metaObject from "@/../.sourceflow/metadata.json";
import { getLanguageAlternates } from "@/functions/getLanguageAlternates";
import { useMemo } from "react";

const BASE_URL = process.env.NEXT_PUBLIC_BASE_URL;
const SITE_NAME = process.env.NEXT_PUBLIC_SITE_NAME;
const SITE_DESCRIPTION = process.env.NEXT_PUBLIC_SITE_DESCRIPTION;
const TWITTER_HANDLE = process.env.NEXT_PUBLIC_TWITTER_HANDLE;
const NEXT_PUBLIC_LOGO = process.env.NEXT_PUBLIC_LOGO;

export const defaultProps = {
  metaObject,
  siteName: SITE_NAME,
  title: SITE_NAME,
  titleTemplate: `%s | ${SITE_NAME}`,
  defaultTitle: SITE_NAME,
  description: SITE_DESCRIPTION,
  images: [
    {
      url: NEXT_PUBLIC_LOGO,
    },
  ],
  twitter: {
    site: TWITTER_HANDLE,
    cardType: "summary_large_image",
  },
};

export default function DynamicPageSeo({
  title,
  robots,
  keywords,
  alternate = { url: "", hreflang: "" },
  hreflang_alternates,
  canonical: __canonical = "",
  description,
  json_schema,
}) {
  const canonical = useMemo(() => {
    let url = __canonical.startsWith("http") ? __canonical : `${BASE_URL}${__canonical}`;
    return !url.endsWith("/") ? `${url}/` : url;
  }, [__canonical]);

  const languageAlternates = useMemo(
    () => getLanguageAlternates({ hreflang_alternates, alternate }),
    [hreflang_alternates, alternate]
  );

  return (
    <>
      <SourceFlowHead
        {...defaultProps}
        title={title.length > 0 ? title : SITE_NAME}
        description={description.length > 0 ? description : SITE_DESCRIPTION}
        canonical={canonical}
        robots={robots}
        keywords={keywords}
        languageAlternates={languageAlternates}
      />
      {json_schema && (
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: json_schema }} />
      )}
    </>
  );
}
